import * as React from 'react';
import { useIntl } from 'react-intl';

import cn from 'classnames';

import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';
import { typographyClass } from '@styles/common';

interface IFormattedDateProps {
  date: string;
  highlighted?: boolean;
}

interface IFormattedTimeProps {
  from: string;
  to: string;
  highlighted?: boolean;
}

const Span = styled.span<{ highlighted?: boolean }>`
  color: ${(props) =>
    props.highlighted ? theme.color.text.positive : theme.color.text.secondary};
  white-space: nowrap;
`;

export const FormattedDate: React.FC<IFormattedDateProps> = ({
  date,
  highlighted,
}) => {
  const { formatDate } = useIntl();

  const dateObj = new Date(date);
  const dayName = formatDate(dateObj, { weekday: 'long' });
  const dayNumber = formatDate(dateObj, {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });

  return (
    <Span
      highlighted={highlighted}
      className={cn({
        [typographyClass.labelRegular]: highlighted,
        [typographyClass.labelRegular400]: !highlighted,
      })}
    >{`${dayName} ${dayNumber}`}</Span>
  );
};

export const FormattedTime: React.FC<IFormattedTimeProps> = ({
  from,
  to,
  highlighted,
}) => {
  const { formatDateTimeRange } = useIntl();

  const formattedRange = formatDateTimeRange(new Date(from), new Date(to), {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <Span
      highlighted={highlighted}
      className={cn({
        [typographyClass.labelRegular]: highlighted,
        [typographyClass.labelRegular400]: !highlighted,
      })}
    >
      {formattedRange}
    </Span>
  );
};
